import React, { useEffect } from "react";
import gql from "graphql-tag";
import { useLazyQuery } from "@apollo/client";

import SubHeader from "../SubHeader";

function CupFixtures(props) {
  const { seasonId, activeCup } = props;

  const FETCH_CUP_FIXTURES = gql`
    query ($seasonId: String!, $activeCup: Int!) {
      getCupFixtures(seasonId: $seasonId, activeCup: $activeCup) {
        _id
        GroupName
        Fixtures {
          Gameweek
          Week
          Matches {
            MatchNumber
            Team1 {
              TeamName
              Points
              Bye
            }
            Team2 {
              TeamName
              Points
              Bye
            }
          }
        }
      }
    }
  `;

  const [
    loadCupFixturesData,
    { loading, data: { getCupFixtures: cupFixtures } = {} },
  ] = useLazyQuery(FETCH_CUP_FIXTURES, {
    variables: { seasonId, activeCup },
  });

  useEffect(() => {
    if (seasonId && activeCup) {
      loadCupFixturesData();
    }
  }, [seasonId, activeCup]);

  return (
    <div>
      {loading ? (
        <div>Loading cup tables...</div>
      ) : (
        cupFixtures &&
        cupFixtures
          .slice()
          .sort((a, b) => a.GroupName - b.GroupName)
          .map((ckf) => {
            return (
              <React.Fragment key={ckf._id}>
                <SubHeader subTitle={ckf.GroupName} />
                <table>
                  <thead>
                    <tr>
                      <th>GW</th>
                      <th>Fixtures</th>
                    </tr>
                  </thead>
                  <tbody>
                    {ckf.Fixtures.map((fixture) => {
                      return (
                        <tr
                          className="cup-knockout-fixtures-row"
                          key={fixture.Week}
                        >
                          <td>{fixture.Gameweek}</td>
                          <td>
                            <table className="cup-knockout-fixtures">
                              <tbody>
                                {fixture.Matches.filter(
                                  (match) =>
                                    !match.Team1.Bye && !match.Team2.Bye
                                ).map((match) => {
                                  return (
                                    <tr key={match.MatchNumber}>
                                      <td width="35%">
                                        {match.Team1.TeamName}
                                      </td>
                                      <td width="10%">{match.Team1.Points}</td>
                                      <td width="10%">vs</td>
                                      <td width="10%">{match.Team2.Points}</td>
                                      <td width="35%">
                                        {match.Team2.TeamName}
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </React.Fragment>
            );
          })
      )}
    </div>
  );
}

export default CupFixtures;
